import image66 from "./image/image66.png";
import frame76 from "./image/Frame76.png";
import chemical from "./icon/chemical.png";
import downhole from "./icon/downhole.png";
import drilling from "./icon/drilling.png";
import exploration from "./icon/exploration.png";
import iot from "./icon/iot.png";
import pipeline from "./icon/pipeline.png";
import renewable from "./icon/renewable.png";
import water from "./icon/water.png";
import partner from "./icon/partner.png";
import client from "./icon/clients.png";
import solar from "./icon/solar.png";
import cairn from "./icon/cairn.png";
import baker from "./icon/baker.png";
import oncg from "./icon/oncg.png";
import reliance from "./icon/reliance.png";
import swaco from "./icon/swaco.png";
import bgGroup from "./icon/bgGroup.png";
import schlumberger from "./icon/schlumberger.png";
import oilPartnerShip from "./icon/oilPartnerShip.png";
import customerIcons from "./icon/customerIcons.png";
import profileIcon from "./icon/profileIcon.png";
import heart from "./icon/heart.png";
import clock from "./icon/clock.png";
import FEEBACK from "./icon/FEEBACK.png";
import doublearrowend from "./icon/doublearrowend.svg";
import feebackStar from "./icon/feebackStar.png";
import logo from "./icon/SuviraEngergyNewLogo.png";
import about_bg from "./image/aboutUs_bg.png";
import Frame76 from "./image/Frame76.png";
import ourMission from "./image/our_mission.png";
import ourMiss from "./icon/ourMission.png";
import Group76 from "./image/Group76.png";
import Group68 from "./image/Group68.png";
import country from "./icon/country.png";
import sector from "./icon/sector.png";
import site from "./icon/site.png";
import workers from "./icon/workers.png";
import Group767 from "./icon/Group76.png";
import findItem from "./icon/findItem.png";
import bigsite from "./icon/bigsite.png";
import diamond from "./icon/diamond.png";
import blogImg from "./icon/blogImg.png";
import uploadResume from "./icon/uploadResume.png";
import workersBg from "./icon/workersBg.png";
import frame76Bg from "./icon/frame76Bg.png";
//
import AboutUs from "./image/Aboutus.jpg";
import blogs from "./image/blogs.jpg";
import blogs1 from "./image/blogs1.jpg";
import career2 from "./image/career2.jpg";
import contactUs from "./image/contactUs.jpg";
import product2 from "./image/product2.jpg";
import playIcon from "./icon/playicon.svg"
import oilGasImage from "./image/oil&gas.jpg"
import arrowRight from "./icon/arrow-right.svg";
import chemicalImage from "./image/chemicalImage.jpg";
import renewableEnergy from "./image/renewableEnergy.jpg";
import lubricantsImg from './image/lubricants.png';
import feedbackMaskSvg from './image/maskfeedback.png';
import feedbackAvatar from './image/feedbackImg.png';
import aboutUsBackground from './image/aboutUsBack.png';
import aboutUsMissionfull from './image/aboutUsMissionfull.png';
import aboutUsExpImg from './image/aboutUSExpGridimg.jpeg';
import aboutUSExpGridimg2 from './image/aboutUSExpGridimg2.png';
import offeringsOilandGas from './image/offeringsOilandGas.png';
import offeringsChemicalNew from './image/offeringsChemicalsNew.png';
import explorationSvg from './icon/explorationSvg.svg';
import drillingSvg from './icon/drillingSvg.svg';
import downholeSvg from './icon/downholeSvg.svg';
import iotSvg from './icon/iotSvg.svg';
import sortSvg from './icon/filterSvg.svg';
import navbaravatar from './icon/navbarAvatar.svg';
import CarrersBanner from './image/carrersBanner.png';
import applyPageImage from './image/applyPageimage.png';
import bannerVideo from './image/bannerVide.mp4';
import aboutusImg from './image/aboutusMissionVision.png';
import OilEngiWithLap from './image/oilengineerWithlap.jpg';
import personWorking from './image/person-working-building-construction.jpg';
import personWalkingDownStears from './image/pipes.png';
import yearsAbout from './image/aboutyears.png';
import newsBanner from './image/newsBanner.jpg';
import waterSvg from './icon/waterSvg.svg';
import pipelineSvg from './icon/pipelineSvg.svg'
import heroImg from './image/heroimg.png'


const icons = {
  country,
  AboutUs,
  blogs,
  career2,
  contactUs,
  product2,
  workersBg,
  blogImg,
  frame76Bg,
  uploadResume,
  diamond,
  findItem,
  Group767,
  sector,
  workers,
  bigsite,
  site,
  image66,
  logo,
  frame76,
  chemical,
  downhole,
  drilling,
  exploration,
  ourMiss,
  iot,
  pipeline,
  renewable,
  water,
  partner,
  client,
  solar,
  cairn,
  baker,
  oncg,
  reliance,
  swaco,
  bgGroup,
  schlumberger,
  oilPartnerShip,
  customerIcons,
  profileIcon,
  heart,
  clock,
  FEEBACK,
  doublearrowend,
  feebackStar,
  about_bg,
  Frame76,
  ourMission,
  Group76,
  blogs1,
  Group68,
  playIcon,
  oilGasImage,
  arrowRight,
  chemicalImage,
  renewableEnergy,
  lubricantsImg,
  feedbackMaskSvg,
  feedbackAvatar,
  aboutUsBackground,
  aboutUsMissionfull,
  aboutUsExpImg,
  aboutUSExpGridimg2,
  offeringsOilandGas,
  offeringsChemicalNew,
  explorationSvg,
  drillingSvg,
  downholeSvg,
  iotSvg,
  sortSvg,
  navbaravatar,
  CarrersBanner,
  applyPageImage,
  bannerVideo,
  aboutusImg,
  OilEngiWithLap,
  personWorking,
  personWalkingDownStears,
  yearsAbout,
  newsBanner,
  waterSvg,
  pipelineSvg,
  heroImg
};

export default icons;
